<template>
  <form>
    <div id="headAssunto" class="vs-con-loading__container">
      <VuePerfectScrollbar class="scroll-assunto-contrato" :settings="settings">
        <vx-card no-shadow title="Nova interação" collapse-action>
          <div>
            <!-- Header: Toggle WATI + Contato/Tipo de Interação -->
            <vs-row vs-type="flex" vs-align="center" vs-justify="space-between" class="mb-6">
              <!-- Esquerda: Toggle de Envio WATI -->
              <vs-col vs-w="4" vs-type="flex" vs-align="center">
                <vs-checkbox
                  v-model="assuntoCliente.enviar_wati_whatsapp"
                  color="success"
                  class="wati-toggle"
                  :disabled="!watiStatus.enabled"
                >
                  <span class="wati-toggle-label" :style="!watiStatus.enabled ? 'color: #94a3b8;' : 'color: #1e293b;'">
                    {{ watiStatus.text }}
                  </span>
                </vs-checkbox>
              </vs-col>

              <!-- Direita: Contato de Confirmação + Botões de Interação -->
              <vs-col vs-w="8" vs-type="flex" vs-justify="flex-end" vs-align="center">
                <!-- Informações de Contato -->
                <div v-if="cliente" style="display: flex; flex-direction: column; align-items: flex-start; text-align: left; margin-right: 24px;">
                  <span style="font-size: 9px; color: #00bba2; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px;">Contato de Confirmação</span>
                  <div style="font-size: 13px; font-weight: 600; color: #2c3e50; margin-top: 2px; display: flex; align-items: center; gap: 4px;">
                    <vs-icon icon="phone" size="14px" :color="isTelefoneInvalido ? '#ea5455' : '#00bba2'"></vs-icon>
                    <span>{{ contatoConfirmacao ? (contatoConfirmacao.nome + ':') : 'Telefone:' }}</span>
                    <ContatoTelefoneLink
                      v-if="telefoneDeConfirmaçao"
                      :telefone="telefoneDeConfirmaçao"
                      :rotulo="formatarTelefone(telefoneDeConfirmaçao)"
                    />
                    <span v-else style="color: #cbd5e1;">Sem telefone</span>
                  </div>
                  <span v-if="isTelefoneInvalido" style="color: #ea5455; font-size: 11px; font-weight: 600; margin-top: 2px;">
                    ⚠️ Telefone inválido para WATI! Corrija no cadastro.
                  </span>
                </div>

                <!-- Botões de tipo de interação -->
                <selectTipoLigacao
                  @select-interaction="selectInteraction"
                  :opcao="cliente.id_tipo_ligacao"
                ></selectTipoLigacao>
              </vs-col>
            </vs-row>

            <!-- Formulário principal - tudo em uma linha -->
            <vs-row vs-type="flex" vs-align="flex-start">
              <!-- Assuntos -->
              <vs-col
                vs-w="3"
                class="px-2"
                vs-type="flex"
                vs-justify="flex-start"
                vs-align="flex-start"
              >
                <div class="w-full">
                  <label class="form-label">Assuntos</label>
                  <el-select
                    filterable
                    clearable
                    class="select-info w-full"
                    placeholder="Selecione..."
                    name="assunto"
                    v-validate="'required'"
                    v-model="assuntoCliente.id_assuntos"
                    :popper-append-to-body="false"
                  >
                    <el-option
                      v-for="assunto in assuntos"
                      class="select-info"
                      :value="assunto.id"
                      :label="assunto.nome + (assunto.abrir_chamado_wati || assunto.enviar_wati ? ' [WATI Ativo]' : '')"
                      :key="assunto.id"
                    >
                      <span style="float: left;">{{ assunto.nome }}</span>
                      <span
                        v-if="assunto.abrir_chamado_wati || assunto.enviar_wati"
                        style="float: right; color: #28c76f; font-size: 11px; font-weight: bold; margin-left: 10px;"
                      >WATI Ativo</span>
                    </el-option>
                  </el-select>
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('assunto')"
                  >{{ $validators.empty }}</span>
                </div>
              </vs-col>

              <!-- Status -->
              <vs-col
                vs-w="2"
                class="px-2"
                vs-type="flex"
                vs-justify="flex-start"
                vs-align="flex-start"
              >
                <div class="w-full">
                  <label class="form-label">Status</label>
                  <el-select
                    color="dark"
                    filterable
                    clearable
                    v-validate="'required'"
                    class="w-full"
                    name="status"
                    :popper-append-to-body="false"
                    v-model="assuntoCliente.status"
                  >
                    <el-option
                      v-for="status in statusAssunto"
                      :key="status.key"
                      :label="status.nome"
                      :value="status.value"
                    ></el-option>
                  </el-select>
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('status')"
                  >{{ $validators.empty }}</span>
                </div>
              </vs-col>

              <!-- Lembrete -->
              <vs-col
                vs-w="2"
                class="px-2"
                vs-type="flex"
                vs-justify="flex-start"
                vs-align="flex-start"
              >
                <vs-input
                  label="Lembrete"
                  v-model="assuntoCliente.data_marcada"
                  type="date"
                  class="w-full"
                />
              </vs-col>

              <!-- Observação -->
              <vs-col
                vs-w="3.5"
                class="px-2"
                vs-type="flex"
                vs-justify="flex-start"
                vs-align="flex-start"
              >
                <vs-textarea
                  label="Observação"
                  v-model="assuntoCliente.obs"
                  counter="250"
                  class="w-full"
                  style="margin-bottom: 0px;"
                />
              </vs-col>

              <!-- Botão Adicionar -->
              <vs-col
                vs-w="1.5"
                class="px-2"
                vs-type="flex"
                vs-justify="flex-end"
                vs-align="flex-start"
              >
                <vs-button
                  color="success"
                  type="relief"
                  :disabled="blockButton"
                  @click="submitForm()"
                  icon="send"
                  class="btn-adicionar w-full"
                  style="height: 38px; margin-top: 20px;"
                >Adicionar</vs-button>
              </vs-col>
            </vs-row>
          </div>
        </vx-card>
        <vs-progress
          v-if="assuntosCliente.length > 0"
          :height="6"
          :percent="100"
          color="primary"
        ></vs-progress>
        <vs-col
          vs-w="12"
          vs-type
          vs-justify="flex-start"
          vs-align="flex-start"
          class="my-3"
          :key="reRender"
        >
          <div class="pl-3" v-if="assuntosCliente.length > 0">
            <VuePerfectScrollbar
              class="p-1 sizeScrollListaAssunto"
              :settings="settings"
            >
              <span :key="indextr" v-for="(tr, indextr) in assuntosCliente">
                <vx-card
                  class="assuntoCliente-card overflow-hidden mb-2"
                  card-border
                  no-shadow
                >
                  <template slot="no-body">
                    <div class="px-2">
                      <div class="my-2">
                        <vs-row>
                          <vs-col vs-w="0.5">
                            <span
                              v-if="tr.tipo == 1"
                              style="font-size: 16px"
                              class="mr-2"
                            >
                              <vs-icon
                                icon="add_ic_call"
                                size="large"
                                color="success"
                              ></vs-icon>
                            </span>
                            <span
                              v-if="tr.tipo == 2"
                              style="font-size: 16px"
                              class="mr-2"
                            >
                              <vs-icon
                                icon="phone_callback"
                                size="large"
                                color="warning"
                              ></vs-icon>
                            </span>
                            <span
                              v-if="tr.tipo == 3"
                              style="font-size: 16px"
                              class="mr-2"
                            >
                              <vs-icon
                                icon="streetview"
                                size="large"
                                color="blue"
                              ></vs-icon>
                            </span>
                            <span
                              v-if="tr.tipo == 4"
                              style="font-size: 16px"
                              class="mr-2"
                            >
                              <vs-icon
                                icon="drive_eta"
                                size="large"
                                color="danger"
                              ></vs-icon>
                            </span>
                            <span
                              v-if="tr.tipo == 5"
                              style="font-size: 16px"
                              class="mr-2"
                            >
                              <vs-icon
                                icon="insert_drive_file"
                                size="large"
                                color="black"
                              ></vs-icon>
                            </span>
                          </vs-col>
                          <vs-col vs-w="10">
                            <vs-col vs-w="12">
                              <span style="font-size: 12px; color: ">
                                <b>
                                  {{ tr.created_at }}
                                  <span
                                    v-if="tr.data_marcada"
                                    class="font-bold"
                                  >
                                    - Lembrete1: {{ tr.data_marcada }}
                                  </span>
                                  <span v-if="tr.colaborador">
                                    - <b>{{ tr.colaborador }}</b></span
                                  >
                                  <span v-if="tr.id_contrato > 0">
                                    - {{ tr.estagio }} N°{{
                                      tr.id_contrato
                                    }}</span
                                  >

                                   <span v-if="tr.telefone">
                                    - {{ tr.telefone }} </span
                                  >
                                </b>
                              </span>
                            </vs-col>
                            <vs-col vs-w="12">
                              <span style="font-size: 16px">
                                <b>{{ tr.assunto }}</b>
                                : {{ tr.obs }}
                              </span>
                            </vs-col> </vs-col
                          ><vs-col
                            vs-w="1.5"
                            vs-type="flex"
                            vs-justify="center"
                            vs-align="center"
                          >
                            <div
                              class="w-full"
                              @click="changeStatus(tr)"
                              style="cursor: pointer"
                            >
                              <vs-row
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="center"
                                vs-align="center"
                                ><vs-col
                                  vs-w="12"
                                  vs-type="flex"
                                  vs-justify="center"
                                  vs-align="center"
                                >
                                  <Badge
                                    :color="
                                      tr.status == '0' ? '#0044f2' : 'success'
                                    "
                                    :text="
                                      tr.status == '0'
                                        ? 'Em processo'
                                        : 'Concluido'
                                    "
                                  ></Badge>
                                </vs-col>
                              </vs-row>
                            </div>
                          </vs-col>
                        </vs-row>
                      </div>
                    </div>
                  </template>
                </vx-card>
              </span>
            </VuePerfectScrollbar>
          </div>
        </vs-col>
      </VuePerfectScrollbar>
    </div>
  </form>
</template>

<script>
import components from "@/components/default/exports.js"
import selectTipoLigacao from "./../../contrato/selectTipoLigacao.vue"

export default {
  props: {
    cliente: {
      require: true,
    },
    contrato: null,
    size: {},
    edit: true,
  },
  data () {
    return {
      modalRespotas: "",
      reRenderModalRespostas: 0,
      selectedAssunto: {},

      assuntosCliente: {},
      assuntos: {},
      statusAssunto: [
        { value: 0, nome: "Em processo", key: 1 },
        { value: 1, nome: "Concluido", key: 2 },
      ],
      assuntoCliente: {
        id_assuntos: null,
        status: 0,
        obs: "",
        data_marcada: "",
        tipo: "",
        enviar_wati_whatsapp: true
      },
      globalWati: true,
      settings: {
        maxScrollbarLength: 160,
        wheelSpeed: 0.6,
        height: 1000,
      },
      blockButton: false,
      reRender: 0,
      contatosCliente: [],
      contatoConfirmacao: null,
    }
  },
  computed: {
    telefoneDeConfirmaçao() {
      if (this.contatoConfirmacao && this.contatoConfirmacao.contato) {
        return this.contatoConfirmacao.contato;
      }
      return this.cliente ? (this.cliente.telefone || this.cliente.telefone_link) : null;
    },
    isTelefoneInvalido() {
      const fone = this.telefoneDeConfirmaçao;
      if (!fone) return true;
      const foneNum = fone.replace(/\D/g, '');
      return foneNum.length !== 10 && foneNum.length !== 11;
    },
    watiStatus() {
      if (!this.globalWati) {
        return {
          enabled: false,
          text: "Envio desativado (Parâmetros)"
        };
      }
      if (this.isTelefoneInvalido) {
        return {
          enabled: false,
          text: "Telefone inválido para WATI"
        };
      }
      if (!this.assuntoCliente.id_assuntos) {
        return {
          enabled: false,
          text: "Selecione um assunto para envio no wati"
        };
      }
      const selected = Array.isArray(this.assuntos)
        ? this.assuntos.find(a => a.id === this.assuntoCliente.id_assuntos)
        : null;
      if (!selected) {
        return {
          enabled: false,
          text: "Selecione um assunto para envio no wati"
        };
      }
      const hasWati = !!selected.abrir_chamado_wati || !!selected.enviar_wati;
      if (!hasWati) {
        return {
          enabled: false,
          text: "Assunto sem envio WATI"
        };
      }
      return {
        enabled: true,
        text: "Notificar via WATI"
      };
    }
  },
  watch: {
    'assuntoCliente.id_assuntos'(newVal) {
      if (newVal) {
        this.assuntoCliente.enviar_wati_whatsapp = this.watiStatus.enabled;
      } else {
        this.assuntoCliente.enviar_wati_whatsapp = false;
      }
    },
    'watiStatus.enabled'(newVal) {
      if (!newVal) {
        this.assuntoCliente.enviar_wati_whatsapp = false;
      }
    }
  },
  methods: {
    async submitForm () {
      // eslint-disable-next-line no-unused-vars
      return new Promise((resolve, reject) => {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.addAssuntoCliente().then(() => {
              this.assuntoCliente = {
                id_assuntos: null,
                status: 0,
                obs: "",
                data_marcada: "",
                tipo: "",
                enviar_wati_whatsapp: true
              }
              resolve()
            }).catch(reject)
          } else {
            this.$vs.notify({
              title: "Preencha todos os campos",
              text: "Os campos não devem ser vazios!",
              color: "danger",
            })
            reject()
          }
        })
      })
    },
    async changeStatus (doc) {
      await this.$vs.loading({ container: "#headAssunto", scale: 0.6 })
      try {
        await this.$http.post(
          'markLembreteAsRead', { id: doc.id, status: !(doc.status) }
        )
        await this.getAssuntosCliente()
        this.reRender += 1
      } catch (err) {
        const error = this.$httpErrors(err)
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        }
      } finally {
        await this.$vs.loading.close("#headAssunto > .con-vs-loading")
      }
    },
    async addAssuntoCliente () {
      this.blockButton = false
      await this.$vs.loading({ container: "#headAssunto", scale: 0.6 })
      try {
        this.assuntoCliente.id_cliente = this.cliente.id
        this.assuntoCliente.id_colaborador = localStorage.id
        if (this.contrato) {
          this.assuntoCliente.id_contrato = this.contrato.id
          this.assuntoCliente.id_estagio = this.contrato.id_estagio
        }
        const res = await this.$http.post(
          "assuntoCliente",
          this.assuntoCliente
        )
        // let logData = {
        //   id_colaborador: localStorage.id,
        //   funcao: "cadastrar",
        //   setor: "comercial",
        //   ip: window.localStorage.getItem("ip"),
        //   texto: "Cadastro do assunto N°" + res.id,
        // }
        // await this.$logger(logData)
        if (this.contrato) {
          await this.getAssuntosContrato()
        } else {
          await this.getAssuntosCliente()
        }

        // Notificação de Sucesso detalhada para o WATI
        if (res.watiEnviado) {
          this.$vs.notify({
            title: "Sucesso",
            text: "Interação adicionada e notificação WATI enviada com sucesso!",
            color: "success"
          });
        } else {
          let text = "Interação adicionada com sucesso!";
          if (res.watiReason === "desativado_global") {
            text += " (Disparo WATI desativado globalmente)";
          } else if (res.watiReason === "desativado_local") {
            text += " (Disparo WATI desmarcado no formulário)";
          } else if (res.watiReason === "assunto_nao_elegivel") {
            text += " (Este assunto não possui WATI configurado)";
          } else if (res.watiReason === "cliente_sem_telefone") {
            text += " (Cliente sem telefone válido)";
          } else if (res.watiErro) {
            text += ` (Erro WATI: ${res.watiErro})`;
          }
          this.$vs.notify({
            title: "Sucesso",
            text: text,
            color: "primary"
          });
        }
      } catch (err) {
        const error = this.$httpErrors(err)
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        }
      } finally {
        this.reRender = (await this.reRender) + 1
        this.blockButton = false
        await this.$vs.loading.close("#headAssunto > .con-vs-loading")
      }
    },
    async getAssuntos () {
      try {
        this.assuntos = await this.$http.get("getAssuntosNovaInteracaoCliente")
      } catch (err) {
        const error = this.$httpErrors(err)
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        }
      }
    },
    async getAssuntosCliente () {
      try {
        this.assuntosCliente = await this.$http.get(
          "getAssuntosCliente/" + this.cliente.id
        )
      } catch (err) {
        const error = this.$httpErrors(err)
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        }
      }
    },
    async selectInteraction (tipo) {
      this.assuntoCliente.tipo = tipo
    },
    formatarTelefone(telefone) {
      if (!telefone) return "";
      let clean = telefone.replace(/\D/g, "");
      if (clean.length === 11) {
        return `(${clean.substring(0, 2)}) ${clean.substring(2, 7)}-${clean.substring(7)}`;
      } else if (clean.length === 10) {
        return `(${clean.substring(0, 2)}) ${clean.substring(2, 6)}-${clean.substring(6)}`;
      }
      return telefone;
    },
    async getGlobalWatiConfig() {
      try {
        const res = await this.$http.get('parametro/1');
        this.globalWati = !!res.enviar_wati_abertura_chamado;
      } catch (err) {
        console.error(err);
      }
    },
    async getContatoConfirmacao() {
      if (this.cliente && this.cliente.id) {
        try {
          const contatos = await this.$http.get("contatoCliente/" + this.cliente.id);
          this.contatosCliente = contatos || [];
          
          const documentos = await this.$http.get("getDocumentosByCliente/" + this.cliente.id);
          if (documentos && documentos.length > 0) {
            const contratoAtivo = documentos.find(doc => doc.id_estagio === 3 && doc.id_contato_confirmacao);
            const contratoQualquer = documentos.find(doc => doc.id_contato_confirmacao);
            const selectedContrato = contratoAtivo || contratoQualquer || documentos[0];
            
            if (selectedContrato && selectedContrato.id_contato_confirmacao) {
              this.contatoConfirmacao = this.contatosCliente.find(c => c.id == selectedContrato.id_contato_confirmacao);
            }
          }
        } catch (e) {
          console.error(e);
        }
      }
    }
  },
  async mounted () {
    await this.$vs.loading({ container: "#headAssunto", scale: 0.6 })
    await this.getAssuntos()
    await this.getAssuntosCliente()
    await this.getGlobalWatiConfig()
    await this.getContatoConfirmacao()
    await this.$vs.loading.close("#headAssunto > .con-vs-loading")
  },
  components: { ...components, selectTipoLigacao },
};
</script>
<style lang="scss">
.scroll-assunto-contrato {
  max-height: 100vh !important;
  height: 100vh !important;
}
.sizeScrollListaAssunto {
  height: 25vh !important;
}
.vx-card__title h4 {
  font-weight: 600;
  text-transform: uppercase !important;
}
.feather-chevron-up {
  width: 30px !important;
  height: 30px !important;
}
.assuntoCliente-card {
  transition-duration: 50ms;
  &:hover {
    transition-duration: 150ms;
    transform: translateY(-3px);
    box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.25);
    background-color: #eeeeee;
    color: black;
    cursor: pointer;

    .grid-view-img {
      opacity: 0.9;
    }
  }
}
</style>
